import type {IDebugger} from "debug";
import debug from "debug";
import {getFormattedLogMessage} from "./loggerUtility";
import {ILogArguments} from "./ILogArguments";

export class LoggerServiceNamespace {

  private readonly logger: IDebugger;

  constructor(public readonly namespace: string) {
    this.logger = debug(namespace);
  }

  public get isEnabled(): boolean {
    return this.logger.enabled;
  }

  public debug({message, showStack, data, showDataOnOneLine, additionalNote}: ILogArguments) {
    const finalMessage = getFormattedLogMessage({message, showStack, data, showDataOnOneLine, additionalNote});
    this.logger(finalMessage);
  }

  public info({message, showStack, data, showDataOnOneLine, additionalNote}: ILogArguments) {
    this.debug({message, showStack, data, showDataOnOneLine, additionalNote});
  }

  public log({message, showStack, data, showDataOnOneLine, additionalNote}: ILogArguments) {
    this.debug({message, showStack, data, showDataOnOneLine, additionalNote});
  }

  public warn({message, showStack, data, showDataOnOneLine, additionalNote}: ILogArguments) {
    const finalMessage = getFormattedLogMessage({message, showStack, data, showDataOnOneLine, additionalNote});
    console.warn(`${this.namespace}: ${finalMessage}`);
  }

  public error({message, showStack, data, showDataOnOneLine, additionalNote, error}: ILogArguments) {
    const finalMessage = getFormattedLogMessage({message, showStack, data, showDataOnOneLine, additionalNote, error});
    console.error(`${this.namespace}: ${finalMessage}`);
  }
}
